import { render, staticRenderFns } from "./UserOverviewCard.vue?vue&type=template&id=4264b05e&scoped=true&"
import script from "./UserOverviewCard.vue?vue&type=script&lang=js&"
export * from "./UserOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264b05e",
  null
  
)

export default component.exports